<template>
	<div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<app-breadcrumb page-title="Recommend Class" />
			</div>
			<div class="col-sm-12 col-md-6 breadcrumb-side-button">
				<div class="float-md-right mb-3 mb-sm-3 mb-md-0">
				</div>
			</div>
		</div>
		<hr
			style="
				border-top: 2px solid black;
				font-weight: bold;
				margin-bottom: 20px !important;
			"
		/>
		<app-table :id="tableId" :options="options">
        </app-table>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import { RecommendClassTableSchema } from "./RecommendClassTableSchema";
import { urlGenerator } from "../../../../Helpers/AxiosHelper";

export default {
	extends: CoreLibrary,
	inject: ["eventHub"],
	name: "RecommendClassTable",
	props: {
		placementId: {
			type: Number,  
		},
	},
	mixins: [RecommendClassTableSchema],
	created() {
		this.options.columns = [...this.tableColumns];
	}, 
	mounted() {
	},
	methods: {
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		
	},
};
</script>
